import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { Observable, of, EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { PropertiesService } from '../services/properties.service';

@Injectable({
  providedIn: 'root'
})
export class ClientPropertiesResolver implements Resolve<any> {
  constructor(private propertiesService: PropertiesService, private auth: AuthService, private router: Router, private flashMessage: FlashMessagesService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return of(this.propertiesService).pipe(
      switchMap(() => {
        const userID = this.auth.user?.id;

        // reject if not authenticated
        if (!userID) {
          this.router.navigate(['/login']);
          return EMPTY;
        }

        // check if already loaded for this user
        const loaded = this.propertiesService.clientProperties ? this.propertiesService.properties.length > 0 : false;
        const forCurrentUser = this.auth.user?.id === this.propertiesService.rentWiseUserID;

        let cachedData = null as any;

        if (loaded && forCurrentUser) {
          cachedData = of({
            properties: this.propertiesService.properties,
          });
        }

        // Request properties from the database for this User
        if (this.auth.isSuperAdmin) {
          const observable = cachedData || this.propertiesService.getAllClientProperties({
            getusers:        true,
            getduplicates:   true,
            getmoveinsurvey: true,
          });

          return observable.pipe(
            switchMap((res: any) => {
              this.propertiesService.clientProperties = true;
              this.propertiesService.rentWiseUserID = '';
              this.propertiesService.properties = res.properties;

              if (route.queryParams.propertyid) {
                this.propertiesService.currentProperty = this.propertiesService.properties.find(p => p._id === route.queryParams.propertyid);
              }

              return of(res);
            })
          );
        }
        else {
          const observable = cachedData || this.propertiesService.getSelfClientProperties({ getmoveinsurvey: true });

          return observable.pipe(
            switchMap((res: any) => {
              this.propertiesService.clientProperties = true;
              this.propertiesService.rentWiseUserID = userID;
              this.propertiesService.properties = res.properties;

              if (route.queryParams.propertyid) {
                this.propertiesService.currentProperty = this.propertiesService.properties.find(p => p._id === route.queryParams.propertyid);
              }

              return of(res);
            })
          );
        }
      })
    );
  }
}
